const ACCESS_TOKEN_KEY = 'access_token'
const CURRENT_USER_ID_KEY = 'current_user_id'
const SESSION_ACTIVE_KEY = 'xiaocai_session_active'
const AUTH_CHANGED_EVENT = 'xiaocai-auth-change'

function canUseBrowserStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'
}

function canUseBrowserCookie() {
  return typeof document !== 'undefined'
}

function secureCookieAttribute() {
  if (typeof window === 'undefined') {
    return ''
  }
  return window.location.protocol === 'https:' ? '; Secure' : ''
}

function markSessionActive() {
  if (canUseBrowserStorage()) {
    window.sessionStorage.setItem(SESSION_ACTIVE_KEY, 'true')
  }
  if (canUseBrowserCookie()) {
    document.cookie = `${SESSION_ACTIVE_KEY}=1; Path=/; SameSite=Lax${secureCookieAttribute()}`
  }
}

function clearSessionActive() {
  if (canUseBrowserStorage()) {
    window.sessionStorage.removeItem(SESSION_ACTIVE_KEY)
  }
  if (canUseBrowserCookie()) {
    document.cookie = `${SESSION_ACTIVE_KEY}=; Path=/; Max-Age=0; SameSite=Lax${secureCookieAttribute()}`
  }
}

export function hasSessionAuthMarker() {
  if (canUseBrowserStorage() && window.sessionStorage.getItem(SESSION_ACTIVE_KEY) === 'true') {
    return true
  }
  if (!canUseBrowserCookie()) {
    return false
  }
  return document.cookie
    .split(';')
    .map((item) => item.trim())
    .some((item) => item === `${SESSION_ACTIVE_KEY}=1`)
}

export function getAccessToken() {
  if (!canUseBrowserStorage()) {
    return ''
  }

  try {
    return window.sessionStorage.getItem(ACCESS_TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export function setAccessToken(token: string) {
  if (!canUseBrowserStorage()) {
    return
  }

  const normalizedToken = token.trim()
  if (!normalizedToken) {
    clearAccessToken()
    return
  }

  window.sessionStorage.setItem(ACCESS_TOKEN_KEY, normalizedToken)
  markSessionActive()
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT))
}

export function getCurrentUserId() {
  if (!canUseBrowserStorage()) {
    return ''
  }

  try {
    return window.sessionStorage.getItem(CURRENT_USER_ID_KEY) || ''
  } catch {
    return ''
  }
}

export function setCurrentUserId(userId: string) {
  if (!canUseBrowserStorage()) {
    return
  }

  window.sessionStorage.setItem(CURRENT_USER_ID_KEY, userId.trim())
}

export function clearCurrentUserId() {
  if (!canUseBrowserStorage()) {
    return
  }

  window.sessionStorage.removeItem(CURRENT_USER_ID_KEY)
}

export function clearAccessToken() {
  if (canUseBrowserStorage()) {
    window.sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  }

  clearSessionActive()
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT))
  }
}
